var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-container',{staticClass:"main-container scroll-height"},[_c('Header'),_c('v-row',{attrs:{"no-gutters":""}},[_c('router-view',{on:{"lring":_vm.loadRing,"ring":_vm.doRing}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }